import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isChrome = /Chrome/.test(navigator.userAgent) && !/Edg|OPR/.test(navigator.userAgent);

if (isChrome) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
} else {
  document.getElementById('root').innerHTML = `
    <div style="
      display:flex;align-items:center;justify-content:center;height:100vh;
      background:#0a1929;color:#fff;font-family:sans-serif;text-align:center;
      padding:20px;
    ">
      <div>
        <div style="font-size:64px;margin-bottom:20px;">⚠️</div>
        <h1 style="color:#26c6da;margin-bottom:12px;">Google Chrome Required</h1>
        <p style="color:#b0bec5;font-size:18px;max-width:500px;line-height:1.6;">
          This application requires <strong style="color:#26c6da;">Google Chrome</strong> for
          speech recognition and real-time interpretation features.<br/><br/>
          Please open this page in Google Chrome to continue.
        </p>
        <p style="color:#78909c;font-size:14px;margin-top:24px;">
          このアプリケーションにはGoogle Chromeが必要です。<br/>
          Google Chromeでこのページを開いてください。
        </p>
      </div>
    </div>
  `;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();